'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _codedmedicalrecords = require('./codedmedicalrecords.component');

var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var codedmedicalrecordsModule = _angular2.default.module('codedmedicalrecords', [_angularUiRouter2.default]).component('codedmedicalrecords', _codedmedicalrecords2.default);

exports.default = codedmedicalrecordsModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/codedmedicalrecords/codedmedicalrecords.js